import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.95 4A4.95 4.95 0 0 0 3 8.95c0 4.95 5.85 9.45 9 10.497C15.15 18.4 21 13.9 21 8.95a4.95 4.95 0 0 0-9-2.847A4.94 4.94 0 0 0 7.95 4"
    }, null, -1)
  ])))
}
export default { render: render }